import { CSE, CSE_METHOD, OPM, OPM_METHOD, WATERFALL, WATERFALL_METHOD } from 'common/constants/allocations';
import { CAP_TABLE_SELECTION_ALIAS, CAP_TABLE_SELECTION_TITLE } from 'common/constants/valuations';
import { smallCurrencyFormat, weightingPercentFormat } from 'common/formats/formats';
import { SelectValueViewer } from 'components';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import {
  ALLOCATION_BACKSOLVE_WEIGHTING_ALIAS,
  ALLOCATION_BACKSOLVE_WEIGHTING_TITLE,
  ALLOCATION_METHOD_ALIAS,
  ALLOCATION_METHOD_TITLE,
  PRESENT_SHARE_VALUES_ALIAS,
  PRESENT_SHARE_VALUES_TITLE,
} from 'pages/Valuations/approaches/backsolveApproach/BacksolveTable/util/constants';
import CapTableListSelection from 'pages/Valuations/components/CapTableListSelection';
import { sortByOrderAndId } from 'utilities';
import allocationMethodListStyles from './AllocationMethodList.styles';
import { GetRowConfigProps, GetSecurityRowsProps } from './types';

const scenariosMethods = [
  {
    id: WATERFALL.toString(),
    name: WATERFALL_METHOD,
  },
  {
    id: CSE.toString(),
    name: CSE_METHOD,
  },
  {
    id: OPM.toString(),
    name: OPM_METHOD,
  },
];

const getSecurityRows = ({ captableList, approach }: GetSecurityRowsProps) => {
  const {
    valuations_approach_backsolve: { applied_methodologies: appliedMethodologies },
  } = approach;
  // if there is at least a primary captable, it will be default value for the applied methodologies
  const pickedCaptableId = appliedMethodologies[0].cap_table;
  const captableSecurities =
    captableList.find(({ id }) => pickedCaptableId.toString() === id.toString())?.securities || [];

  return sortByOrderAndId(captableSecurities).map(s => ({
    value: s.name,
    alias: s.security.toString(),
    securityName: s.name,
    readOnly: true,
    gridType: 'number',
    customKey: s.security,
    format: smallCurrencyFormat,
    hasTotal: true,
  }));
};

const getRowConfig = ({ captableList, approach, isDisabled }: GetRowConfigProps) => [
  {
    largeHeader: true,
    ignoreRowCopy: true,
  },
  {
    alias: ALLOCATION_METHOD_ALIAS,
    className: 'subtitle-bold division-bottom-only',
    customKey: 'allocationMethod',
    dataEditor: (props: any) => (
      <GridSelect
        extraStyles={allocationMethodListStyles}
        menuPosition="absolute"
        objectOptions={{ displayKey: 'name', valueKey: 'id' }}
        options={scenariosMethods}
        {...props}
      />
    ),
    dbType: 'string',
    defaultValue: WATERFALL,
    expr: '',
    readOnly: isDisabled,
    rowNumber: 2,
    value: ALLOCATION_METHOD_TITLE,
    valueViewer: (props: any) => (
      <SelectValueViewer options={scenariosMethods} objectOptions={{ displayKey: 'name', valueKey: 'id' }} {...props} />
    ),
    ignoreRowCopy: true,
  },
  {
    value: CAP_TABLE_SELECTION_TITLE,
    alias: CAP_TABLE_SELECTION_ALIAS,
    rowNumber: 3,
    customKey: 'capTableSelection',
    readOnly: isDisabled,
    dbType: 'string',
    defaultValue: captableList.find(item => item.is_primary)?.id,
    expr: '',
    dataEditor: (props: any) => <CapTableListSelection {...props} options={captableList} />,
    valueViewer: (props: any) => (
      <SelectValueViewer options={captableList} objectOptions={{ displayKey: 'name', valueKey: 'id' }} {...props} />
    ),
    ignoreRowCopy: true,
  },
  {
    value: ALLOCATION_BACKSOLVE_WEIGHTING_TITLE,
    alias: ALLOCATION_BACKSOLVE_WEIGHTING_ALIAS,
    rowNumber: 4,
    customKey: 'allocationBacksolveWeighting',
    readOnly: isDisabled,
    dbType: 'string',
    format: weightingPercentFormat,
    gridType: 'percentage',
    dbDecimalPlaces: 2,
    expr: '',
    hasTotal: true,
  },
  {
    alias: PRESENT_SHARE_VALUES_ALIAS,
    defaultValue: '',
    expr: '',
    readOnly: true,
    rowNumber: 5,
    value: PRESENT_SHARE_VALUES_TITLE,
  },
  ...getSecurityRows({ captableList, approach }),
];
export default getRowConfig;
